import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { setColor } from "../../../assets/styles/styles";
import DesktopBackground from "../assets/backgrounds/Web_Desktop_BG_Intraverse_LandingPage.png";
// import { size } from '../../../assets/styles/mediaBreakpoints';

const LandingPageContainer = ({ children, showOutline, explorePage }) => (
    <IntraverseHomeContainer explorePage={explorePage}>
        {showOutline && <BorderOutlineStroke />}
        {children}
    </IntraverseHomeContainer>
);

LandingPageContainer.propTypes = {
    children: PropTypes.node,
    showOutline: PropTypes.bool,
};

export default LandingPageContainer;

const BorderOutlineStroke = styled.div`
    position: absolute;
    width: 97%;
    height: 100%;
    top: 53px;
    opacity: 0.2;
    pointer-events: none;
    // top: 0.3%;
    left: 1.5%;
    z-index: 3000;
    border: ${() => `3px solid ${setColor.redBackground}`};
    // border-top: none;

    @media (max-width: 768px) {
        // height: calc(100% - 60px);
        border-top: none;
        top: 60px;
    }
`;

const IntraverseHomeContainer = styled.div`
    width: 100%;
    height: auto;
    position: absolute;
    overflow: hidden;
    background: ${(props) =>
        props.explorePage === true
            ? `url(${DesktopBackground}) no-repeat`
            : "none"};
     background-size: ${(props) => (props.explorePage === true ? "100% 70%" : "none")};
`;

